var render = function render(){var _vm=this,_c=_vm._self._c;return _c('book-equipment-overview',{attrs:{"actions":_vm.actions,"productionType":_vm.productionType},scopedSlots:_vm._u([{key:"secondaryMenu",fn:function(){return [_c('book-productions-menu',{attrs:{"productionType":_vm.productionType}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }